import { useCallback, useState } from 'react';
import type { Dispatch, SetStateAction } from 'react';

import type { MachineSingle } from 'app/dataTypes/vending/Machines.types';
import { defaultVendingMachineKind } from 'app/dataTypes/vending/MachineKind.types';


const defaultState: MachineSingle = {
  id: 0,
  title: '',
  number: '',
  modelId: 0,
  orgId: 0,
  buildingId: 0,
  salePointId: 0,
  versionId: 0,
  kind: defaultVendingMachineKind,
  placeId: '',
};

type FormActions = {
  update: Dispatch<SetStateAction<MachineSingle>>;
  clear: () => void;
  fillFromData: () => void;
};

export type MachineForm = [MachineSingle, FormActions];

export const defaultMachineForm: MachineForm = [
  defaultState,
  {
    update: () => { },
    clear: () => { },
    fillFromData: () => { },
  },
];

export default function useMachineForm(single: MachineSingle): MachineForm {
  const [state, setState] = useState<MachineSingle>(defaultState);

  const clear = useCallback(() => {
    setState(defaultState);
  }, []);

  const fillFromData = useCallback(() => {
    setState(single);
  }, [single]);

  return [state, {
    update: setState,
    clear,
    fillFromData,
  }];
}
